<template>
  <div>
    <Input
      @on-focus="openGroup = true"
      :value="name"
      readonly
      placeholder="请选择"
      :clearable="clearable"
      @on-clear='clear'
      :disabled='disabled'
    ></Input>

    <Drawer
      :placement="placement"
      :closable="false"
      v-model="openGroup"
      draggable
      class="my-drawer"
    >
      <groupTree @group="reGroup" :filterGroup='filterGroup' :sousuo='true'></groupTree>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["name", "placement","clearable","disabled","filterGroup"],
  data() {
    return {
      openGroup: false,
    };
  },
  methods: {
    reGroup(v) {
      this.openGroup = false;

      if (this.name == v.name) {
        return;
      }
      this.$emit("update:id", v.id);
      this.$emit("update:name", v.name);
      this.$emit("group", v);
    },
    clear(){
      this.$emit("update:id", '');
      this.$emit("update:name", '');
    }
  },

};
</script>



// WEBPACK FOOTER //
// src/components/common/selectGroup.vue